import React, { useRef, useState, useEffect } from 'react';
import { Input, Modal, message, Spin } from 'antd';
import { Badge, Avatar } from '@nextui-org/react';
import './Navbar.css';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { persistor } from '../../redux/store';
import { logout } from '../../redux/features/auth/authActions';
import MobileSideBar from '../Layout/MobileLayout/MobileSideBar';
import { FiAlignRight } from 'react-icons/fi';
import { IoClose } from 'react-icons/io5';
import ProfileDropdown from '../Dropdown/ProfileDropdown';
import { decryptData } from '../../utils/encryptData';
import NoficationDropdown from '../Notification/NoficationDropdown';

const { Search } = Input;

function Navbar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sidebarRef = useRef(null);

  const [toggleBtn, setToggleBtn] = useState(false);

  const { loading, isAuthenticated, rl, em } = useSelector(
    (state) => state.auth
  );

  const role = decryptData(rl);

  //logout
  const handleLogout = async (e) => {
    try {
      if (!isAuthenticated && !em && !rl) {
        message.success('You are already logout!'); // check before logout user is alredy login
        return;
      }

      const email = await decryptData(em); // decrypt email

      if (!email === null) {
        message.error('Something went wrong!');
        return;
      }

      await dispatch(logout({ email })).unwrap();

      message.success('Successfully logout!');

      persistor.purge();
      navigate('/');
    } catch (err) {
      const errorMessage = err.error || 'Logout failed';
      message.error(errorMessage);
    }
  };

  //confirm box
  const showConfirm = () => {
    Modal.confirm({
      title: 'Confirm Logout',
      content: 'Are you sure you want to log out?',
      okText: 'Log out',
      cancelText: 'Cancel',
      onOk() {
        handleLogout();
      },
    });
  };

  const toggleClose = () => {
    setToggleBtn(!toggleBtn);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setToggleBtn(false); // Close sidebar if click is outside
      }
    }

    // Add event listener htmlFor detecting clicks
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Remove event listener on cleanup
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [sidebarRef]);

  const navigateRegiPage = () => {
    if (isAuthenticated && em) {
      message.warning('You are already registered!');
      return;
    } else {
      navigate('/register');
    }
  };

  return (
    <>
      <Spin spinning={loading} fullscreen />

      <header
        className="flex order-b bg-background-secondary-color ml-[-250px] lg:ml-0 w-full w-auto  py-2 sm:px-8 px-6 font-popins min-h-[70px]  relative z-50"
        style={{
          position: 'fixed',
          width: 'auto',
          zIndex: 1000,
          top: 0,
          left: 250,
          right: 0,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          font: 'poppins',
        }}
      >
        {/* Logo */}
        <div className="flex flex-wrap items-center lg:gap-y-2  w-full">
          <Link to="/">
            <img src="/img/logo.png" alt="Logo" className="w-36 lg:hidden" />
          </Link>

          {/* Seach feild */}

          <div
            id="collapseMenu"
            className="lg:ml-10 max-lg:hidden lg:!block max-lg:before:fixed max-lg:before:bg-black max-lg:before:opacity-50 max-lg:before:inset-0 max-lg:before:z-50"
          ></div>
          {/* TODO: need to fix btn vidibility in mobile view */}
          <div className="ml-auto">
            {/* <ProfileDropdown /> */}

            {!isAuthenticated && !em ? (
              // Show Register and Login buttons if the user is NOT authenticated
              <>
                {/* <Link to="/register"> */}
                <div className="flex flex-inline">
                  <button
                    onClick={navigateRegiPage}
                    className="hidden sm:flex flex-inline md:px-5 md:py-2 mr-3 text-sm px-2 py-1 rounded-lg text-white font-poppins border-2 border-btn-color hover:border-btn-hover-color bg-transparent hover:scale-105 hover:transform-all duration-300"
                  >
                    Register
                  </button>
                  {/* </Link> */}

                  <Link to="/login">
                    <button className="flex md:px-5 md:py-2 px-2 py-1 text-sm rounded-lg mr-4 text-white font-poppins border-2 border-btn-color hover:border-btn-hover-color bg-transparent hover:scale-105 hover:transform-all duration-300">
                      Log In
                    </button>
                  </Link>
                </div>
              </>
            ) : (
              <>
                <div className="flex flex-initial">
                  {role === 'admin' && (
                    <div className="mt-2 mr-4 items-center justify-center">
                      <NoficationDropdown />
                    </div>
                  )}

                  <div className="mr-5 mt-1">
                    <ProfileDropdown />
                  </div>
                </div>
              </>
            )}
          </div>

          {!toggleBtn ? (
            <FiAlignRight
              onClick={toggleClose}
              className="w-[25px] h-[25px] md:w-[35px] md:h-[35px] lg:hidden cursor-pointer text-white"
            />
          ) : (
            <IoClose
              onClick={toggleClose}
              className="w-[25px] h-[25px] md:w-[35px] md:h-[35px] lg:hidden cursor-pointer text-white"
            />
          )}
        </div>
      </header>

      {/* Mobile Sidebar */}
      {toggleBtn && (
        <div ref={sidebarRef}>
          <MobileSideBar onClick={toggleClose} />
        </div>
      )}
    </>
  );
}

export default Navbar;
